// Predicates used in `enabled:` clauses of TanStack Query hooks. Each
// returns false (and narrows nothing) for null inputs so the query stays
// disabled until the caller has a concrete value to pass.

export function isValidBlockHeight(h: number | null): h is number {
  return h !== null && Number.isInteger(h) && h >= 0;
}

export function isValidDomainId(id: number | null): id is number {
  return id !== null && Number.isInteger(id) && id >= 1;
}
